/**
 * Opções pré-definidas de Cargo/Função
 */
export enum PositionEnum {
    PREFEITO = 'Prefeito',
    SECRETARIO = 'Secretário',
    ASSESSOR = 'Assessor',
    TECNICO = 'Técnico',
    ANALISTA = 'Analista',
}

/**
 * Array com todas as opções de Cargo/Função
 */
export const POSITION_OPTIONS = [
    { value: PositionEnum.PREFEITO, label: PositionEnum.PREFEITO },
    { value: PositionEnum.SECRETARIO, label: PositionEnum.SECRETARIO },
    { value: PositionEnum.ASSESSOR, label: PositionEnum.ASSESSOR },
    { value: PositionEnum.TECNICO, label: PositionEnum.TECNICO },
    { value: PositionEnum.ANALISTA, label: PositionEnum.ANALISTA },
];

/**
 * Mapeia valor armazenado para a opção correspondente
 */
export const getPositionLabel = (value: string | null | undefined): string => {
    if (!value) return '';
    return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
};
